<template>

    <div class="row my-md-3 my-xl-4">
      <div class="col col-lg-10 mx-auto text-center">
        <h2 class="mb-4"><span class="blue-light">Subscribe to</span> get new courses from CSDP training programme <span class="blue-light">in your inbox</span></h2>
        <div v-if="!emailSent">
          <div class="d-flex mb-2 pt-lg-3 mx-auto" style="max-width: 630px;">
            <InputText
              type="email"
              v-model="email"
              placeholder="Email address"
              class="searchInput w-75 me-1 me-md-2 me-lg-3"
            />
            <Button :disabled="isButtonDisabled" :loading="subscribing" @click="subscribe" >Subscribe</Button>
          </div>

          <div class="d-inline-flex align-items-start align-items-md-center mb-3">
            <Checkbox v-model="agree" inputId="agree" name="agree" value="true" class="me-2"/>
            <label for="agree" class="ms-1 fs-14">Yes, I agree to the conditions below and I want to get updated in my
              inbox.</label>
          </div>
          <div v-if="error" class="alert alert-light my-3 mx-auto" style="max-width: 630px;">
            <strong>Error when subscribing!</strong><br>
            <span class="text-muted fs-14"><strong>{{ errorMsg }}.</strong></span>
          </div>

        </div>
        <div v-else class="alert alert-light my-3 mx-auto" style="max-width: 630px;">
          <strong>Thank you for subscribing!</strong><br>
          <span class="text-muted fs-14">You will receive an email to this address: <strong>{{ email }}</strong>, with instructions to confirm your subscription.</span>
        </div>

        <div class="my-3">
          <small class="text-muted fs-13">Information supplied for subscribing the mailing list is managed, pursuant to Regulation 45/2001 on personal data protection, by the Goalkeeper Schoolmaster Administrator in EEAS-ISP1. If you have any questions please send an e-mail to <a href="mailto:goalkeeper.schoolmaster@eeas.europa.eu">goalkeeper.schoolmaster@eeas.europa.eu</a>.</small>
        </div>
      </div>
    </div>

</template>

<script lang="ts" src="./Subscribe.ts"></script>

<style scoped>

</style>